export const EntryLineFlag = {
  none: 0,
  allotmentNoPlace: 1,
  flightLuggage: 2,
  noCachedPrice: 4,
};
